module.exports = __webpack_public_path__ + "static/arm2-2b7383a0535c85de43554a755fb62be9.gif";